import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateLuminaire } from '../../redux/luminaire/luminaire_actions';

const mapStateToProps = state => ({
  isDuplicating: state.lighting.luminaire.isDuplicating,
  errorMessage: state.lighting.luminaire.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateLuminaire(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);


// WEBPACK FOOTER //
// ./src/modal/luminaire/LuminaireDuplicateModal.js